// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'mail-plus-solid';

export const Component = () => (
  <path d='M24.042 4.969c.335 0 .48.143.48.479 0 .335-.145.479-.48.479H21.6v2.442c0 .335-.191.526-.527.526-.335 0-.478-.191-.478-.526V5.927h-2.443c-.335 0-.479-.144-.479-.48 0-.335.144-.478.48-.478h2.442V2.527c0-.336.143-.527.478-.527.336 0 .527.191.527.527v2.442h2.442Zm-5.89 1.963H1.485c-.431 0-.766.144-1.054.431A1.378 1.378 0 0 0 0 8.37v.335l9.052 5.843c.239.144.526.239.766.239s.527-.096.766-.24l9.052-5.842V8.37a1.38 1.38 0 0 0-.431-1.006 1.411 1.411 0 0 0-1.054-.431Zm-8.334 8.813a2.61 2.61 0 0 1-1.293-.336L0 9.854V20.15c0 .431.144.766.431 1.054.288.287.623.43 1.054.43h16.667c.43 0 .766-.143 1.053-.43.288-.288.432-.623.432-1.054V9.854l-8.573 5.555a2.56 2.56 0 0 1-1.245.336h-.001Z' />
);

export const viewBox = '0 0 25 25';
